import { Dispatch, SetStateAction } from "react";
import { colors } from "@src/packages/chime-ui/system";

export const incodeUiConfig = {
  theming: {
    designTokens: {
      button: {
        primary: {
          surface: { default: colors.brightGreen },
          text: { default: colors.notBlack },
        },
      },
    },
  },
};

const INCODE_CLIENT_ID = process.env.INCODE_CLIENT_ID ?? "";
const INCODE_API_URL = process.env.INCODE_API_URL ?? "";

export const setupIncode = async (
  vendorToken: string,
  interviewId: string,
  setIncode: Dispatch<SetStateAction<undefined | string>>,
  setToken: Dispatch<SetStateAction<string>>,
) => {
  // From https://docs.incode.com/docs/omni-api/integration-guide/#step-5
  let apiURL = INCODE_API_URL;
  //     Initialize the Incode SDK using the token received from the above steps. It is VERY IMPORTANT to add 0/ to
  //     the end of the API URL. This endpoint allows for API requests that don't contain the API key and will work
  //     with just the token.
  if (vendorToken) apiURL += "0/";
  const instance = window.OnBoarding.create({
    clientId: INCODE_CLIENT_ID,
    apiURL: apiURL,
    lang: "en",
    encrypt: true,
  });

  if (vendorToken) {
    await instance.warmup();
    // needed here since instance.createSession used to implicitly call it
    await instance.sendFingerprint({ token: vendorToken });
    setIncode(instance);
    setToken(vendorToken);
  } else {
    // this can be deleted once https://github.com/1debit/penny/pull/2456 is merged
    instance.createSession("ALL", null, { interviewId }).then(async (session: any) => {
      await instance.warmup();
      setIncode(instance);
      setToken(session.token);
    });
  }
};
